export default {"src":"/_next/static/media/ImportantIconSoftRed.63a3a78d.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};